import { Grid } from '@mui/material'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import WeeklyEmails from '../setting/components/WeeklyEmails'

// Standalone page so the weekly-email editor lives on its own Sidenav tab
// instead of being buried inside the Settings tab strip.
function WeeklyEmailsPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container mt={10}>
        <Grid item xs={12}>
          <WeeklyEmails />
        </Grid>
      </Grid>
    </DashboardLayout>
  )
}

export default WeeklyEmailsPage
